import React from 'react'
import _ from 'underscore'
import styled from 'styled-components'

import Tooltip from 'components/Tooltip'
import KeyboardAccessible from 'components/KeyboardAccessible'

import supportedTags from 'pages/shared/Alert/supportedTags'

import { color } from 'styles/colors'

type Props = {
  tags: string[] | null | undefined
}

const Tags = ({ tags }: Props) => {
  return (
    <>
      {tags && _.map(_.intersection(tags, _.keys(supportedTags)), (tag) => (
        <Tooltip key={tag} title={supportedTags[tag].tooltip}>
          <S.Tag readOnly>{tag}</S.Tag>
        </Tooltip>
      ))}
    </>
  )
}

export default Tags

const S = {
  Tag: styled(KeyboardAccessible)`
    background-color: ${color('tagBackground')};
    color: ${color('tagText')};
    border-radius: 5px;
    margin-left: 10px;
    padding 0 5px;
    font-weight: bold;
    cursor: default;
    border: 1px solid ${color('tagBorder')};
  `
}
